import { render } from "./FeedbackTicketList.vue?vue&type=template&id=2f8b4b0c"
import script from "./FeedbackTicketList.vue?vue&type=script&lang=js"
export * from "./FeedbackTicketList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__